import React from 'react';
import { Link } from 'react-resource-router';
import Button from '@atlaskit/button';
import { Inline } from '@atlaskit/primitives';
import { extractTicketTypeId } from '../../../../../../common/utils/ticket-types';
import { RequestTypeIcon } from './styled';
export const RequestTypeLink = ({
  requestTypeCategories,
  simplifiedProject,
  projectKey,
  requestType,
  isServiceProject
}) => {
  if (isServiceProject) {
    const id = extractTicketTypeId(requestType.id);
    const category = requestTypeCategories === null || requestTypeCategories === void 0 ? void 0 : requestTypeCategories[parseInt(id, 10)];
    const requestTypeUrl = simplifiedProject ? `/jira/servicedesk/projects/${projectKey}/settings/issuetypes/${id}` : `/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${category}/request-type/${id}/request-form`;
    return /*#__PURE__*/React.createElement(Button, {
      appearance: "link",
      spacing: "none",
      href: requestTypeUrl,
      component: Link,
      iconBefore: /*#__PURE__*/React.createElement(RequestTypeIcon, {
        src: requestType.iconUrl,
        alt: ""
      })
    }, requestType.name);
  }
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(RequestTypeIcon, {
    src: requestType.iconUrl,
    alt: ""
  }), requestType.name);
};